import { Map } from 'immutable';
import AppC from '../constants/app';
import scoreBoardC from '../constants/scoreBoard';
import intlC from '../constants/intl';
import homeC from '../constants/home';
import faQC from '../constants/faq';
import toolboxC from '../constants/toolbox';
import alertC from '../constants/alert';
import userC from '../constants/user';
import headerC from '../constants/header';
import bannerC from '../constants/banner';
import SRviewC from '../constants/SRview';
import SearchC from '../constants/search';
import ServiceCatalogC from '../constants/serviceCatalog';
import MySettingsC from '../constants/mySettings';
import customIframeC from '../constants/customIframe';
import newsC from '../constants/news';

export default function initialState() {
  return {
    app: Map({
      [AppC.SSP_PERMISSIONS_LIST]: {
        isFetched: false,
        onlineHelp: false,
        enableDirectActions: false,
        reportIssueEnabled: false,
        submitRequestEnabled: false,
        endUserCanChangeSettings: false,
        canAccessAdminPortal: false,
        fromF11:false,
        canSendAnalytics: false,
        hideHelp:false,
        serviceCatalogEnabled:false,
        aienabled: false
      },
      [AppC.SSP_PREFERENCES]: {
        enableIncidentSubmitBtn: true,
        enableRequestSubmitBtn: true,
        footerEnabled:true
      },
      [AppC.THEME]: {},
      [AppC.FETCHING_COUNTER]: 0,
      [AppC.IS_FETCHING]: false
    }),

    news: Map({
      [newsC.NEWS]: {
        data: [],
        [newsC.OPEN_CLOSED_CLASS_INDEX]: 1,
        [newsC.HAS_UNREAD]: true
      }
    }),
    serviceCatalog: Map({
      [ServiceCatalogC.CATALOG_ITEMS]: [
        {
          type: 'folder',
          name: 'root',
          title: 'Home',
          description: 'asdasd dsadasD',
          children: [
            {
              type: 'folder',
              name: 'initialState1',
              title: 'initialState1 folder 1',
              description: 'initialState1 dsadasD',
              children: []
            },
            {
              type: 'folder',
              name: 'initialState2',
              title: 'initialState1 folder 2',
              description: 'initialState1 dsadasD',
              children: []
            }
          ]
        }
      ]
    }),
    alert: Map({
      [alertC.ALERT_PROPS]: {
        alertIcon: '',
        alertTitle: 'Oh No',
        alertText: 'Something went wrong',
        alertStyle: 'info',
        displayTime: 3000,
        closeButton: false
      },
      [alertC.ALERT_ACTIVE]: false
    }),
    home: Map({
      [homeC.WIDGET_LIST]: {
        widgets: {},
        order: []
      }
    }),
    auth: Map({
      logedIn: false,
      keepAliveInterval: false
    }),
    user: Map({
      [userC.USER_CALCULATED_NAME]: '',
      [userC.USER_NAME]: '',
      [userC.USER_PHOTO]: '',
      [userC.USER_PHOTO_UPDATED]: false,
      [userC.TIME_ZONE]: '',
      [userC.LOCALE]: '',
      [userC.FIRST_DAY_OF_WEEK]: '',
      [userC.INPUT_DATE]: '',
      [userC.SSP_THEME]: '',

      [userC.IS_GUEST]: false
    }),
    header: Map({
      [headerC.USER_LOGO]: ''
    }),
    banner: Map({
      [bannerC.USER_BANNER]: {
        [bannerC.BANNER_TEXT]: '',
        [bannerC.IMAGE_FILE_PATH]: '',
        [bannerC.IMAGE_OVERLAY]: '',
        [bannerC.TEXT_COLOR]: '',
        [bannerC.BANNER_LINK]: '',
        [bannerC.BANNER_HEIGHT]: 'L'
      }
    }),
    scoreBoard: Map({
      [scoreBoardC.TABS]: Map({
        [scoreBoardC.MY_REQUEST_TAB]: Map({
          [scoreBoardC.TAB_CAPTION_KEY]: '',
          [scoreBoardC.TAB_NO_DATA_CAPTION_KEY]: '',
          [scoreBoardC.ACTIVE_REQUESTS_COUNT]: 0,
          [scoreBoardC.ACTIVE_REQUESTS_ARRAY_WIDGET]: [],
          [scoreBoardC.ACTIVE_REQUESTS_ARRAY]: [],
          [scoreBoardC.BADGES_CUSTOM_FIELDS]: [],
          [scoreBoardC.COLUMNS_CUSTOM_FIELDS]: [],
          [scoreBoardC.STATIC_FILTER_ID]: ''
        }),
        [scoreBoardC.RECENTLY_CLOSED_TAB]: Map({
          [scoreBoardC.TAB_CAPTION_KEY]: '',
          [scoreBoardC.TAB_NO_DATA_CAPTION_KEY]: '',
          [scoreBoardC.CLOSED_REQUESTS_COUNT]: 0,
          [scoreBoardC.CLOSED_REQUESTS_ARRAY_WIDGET]: [],
          [scoreBoardC.CLOSED_REQUESTS_ARRAY]: [],
          [scoreBoardC.BADGES_CUSTOM_FIELDS]: [],
          [scoreBoardC.COLUMNS_CUSTOM_FIELDS]: [],
          [scoreBoardC.STATIC_FILTER_ID]: ''
        }),
        [scoreBoardC.SUPERVISED_REQUESTS_TAB]: Map({
          [scoreBoardC.TAB_CAPTION_KEY]: '',
          [scoreBoardC.TAB_NO_DATA_CAPTION_KEY]: '',
          [scoreBoardC.SUPERVISED_REQUESTS_COUNT]: 0,
          [scoreBoardC.SUPERVISED_REQUESTS_ARRAY_WIDGET]: [],
          [scoreBoardC.SUPERVISED_REQUESTS_ARRAY]: [],
          [scoreBoardC.BADGES_CUSTOM_FIELDS]: [],
          [scoreBoardC.COLUMNS_CUSTOM_FIELDS]: [],
          [scoreBoardC.STATIC_FILTER_ID]: ''
        }),
        [scoreBoardC.PENDING_MY_APPROVAL_TAB]: Map({
          [scoreBoardC.TAB_CAPTION_KEY]: '',
          [scoreBoardC.TAB_NO_DATA_CAPTION_KEY]: '',
          [scoreBoardC.PENDING_REQUESTS_COUNT]: 0,
          [scoreBoardC.PENDING_REQUESTS_ARRAY_WIDGET]: [],
          [scoreBoardC.PENDING_REQUESTS_ARRAY]: [],
          [scoreBoardC.BADGES_CUSTOM_FIELDS]: [],
          [scoreBoardC.COLUMNS_CUSTOM_FIELDS]: [],
          [scoreBoardC.STATIC_FILTER_ID]: ''
        })
      }),
      [scoreBoardC.ACTIVE_TAB_NAME]: '',
      [scoreBoardC.TABS_ORDER]: []
    }),
    intl: Map({
      [intlC.INTL_OBJECT]: {
        'ssp.discardChanges': 'Discard changes?',
        'ssp.selfService': 'FAQ',
        'ssp.viewSR.ticketInfo': 'Ticket Info',
        'ssp.viewSR.preview': 'Preview',
        'ssp.alert.workflow.update.success': 'Your action was received and successfully applied on SR',
        'ssp.alert.workflow.update.failed.1': 'Your action could not be applied on SR',
        'ssp.alert.workflow.update.failed.2': 'either because the action item is locked, or because it is no longer available.',
        'ssp.idPrefix':'#',
        'ssp.viewSR.indicateReopenReason':'Please indicate the reason you are re-opening this',
        'ssp.viewSR.cancel': 'Cancel',
        'ssp.viewSR.typeNote': 'Type your note...',
        'ssp.viewSR.submitNote': 'Submit note'
      }
    }),
    faq: Map({
      [faQC.FAQ_LIST]: []
    }),
    toolbox: Map({
      [toolboxC.TOOLBOX_LIST]: []
    }),
    SRview: Map({
      [SRviewC.SR_DATA]: {
        id: '',
        sr_type: { valueCaption: '' },
        title: { valueCaption: '' },
        problem_type: { valueCaption: '' },
        problem_sub_type: { valueCaption: '' },
        third_level_category: { valueCaption: '' },
        description: { valueCaption: '', keyCaption: '', type: '' },
        notes: { value: [] },
        messages: { value: [] },
        attachments: { value: [] },
        activities: { value: [] },
        status: { valueClass: '' },
        archive: { value: 0 },
        solution: { valueCaption: '', keyCaption: '' }
      },
      [SRviewC.SSP_SR_VIEW]: [],
      [SRviewC.TABS_ORDER]: []
    }),
    Search: Map({
      [SearchC.SEARCH_DATA]: {
        order: [],
        itemsPerSource: 5,
        sr: [],
        faq: [],
        categories: [],
        templates: [],
        serviceCatalog: []
      },
      [SearchC.CURRENT_FILTER]: '',
      [SearchC.SEARCH_KEYWORD]: ''
    }),
    MySettings: Map({
      [MySettingsC.MY_SETTINGS_DATA]: {
        fields: [],
        minimumAnswerLength: 0
      },
      [MySettingsC.MY_LANGUAGE]: {
        values: []
      },
      [MySettingsC.MY_TIMEZONE]: {
        values: []
      },
      [MySettingsC.MY_DATE_INPUT_STYLE]: {
        values: []
      },
      [MySettingsC.MY_FIRST_DAY_OF_WEEK]: {
        values: []
      },
      [MySettingsC.MY_DATE_FORMAT]: {
        values: []
      },
      [MySettingsC.MY_SECURITY_QUESTIONS]: {
        values: []
      },

      [MySettingsC.MY_CUSTOM_LIST_VALUES]: {
        values: []
      },
      [MySettingsC.MY_SSP_THEME]: {
        values: []
      }
    }),
    customIframe: Map({
      [customIframeC.IFRAME_SRC]: '',
      [customIframeC.IFRAME_HEIGHT]: 300,
      [customIframeC.IFRAME_SCROLL]: false
    })
  };
}



// WEBPACK FOOTER //
// ./store/initialstate.js